import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '@websky/core/src/theme';
import theme from './FlightCardAirlineInfo.css';
var FlightCardAirlineInfo = function (_a) {
    var className = _a.className, airline = _a.airline, flightNumber = _a.flightNumber;
    var css = useTheme('FlightCard').FlightCard;
    var t = useTranslation('FlightCard').t;
    return (React.createElement("div", { className: cn(className, theme.wrapper) },
        React.createElement("span", { className: theme.airline__operating },
            t('Flight is operated by'),
            " ",
            airline.name,
            ","),
        React.createElement("span", { className: css.airline__number }, flightNumber)));
};
export default FlightCardAirlineInfo;
